<template>
  <div class="top-bar">
    <div class="logo-container">
      <img src="../../public/images/logo.png" alt="Logo" class="logo" />
      <span class="software-name">智学慧评</span>
    </div>
    <div class="right-container">
      <!-- 搜索图标 -->
      <i class="el-icon-search search-icon"></i>
      <!-- 翻译图标 -->
      <i class="el-icon-message translation-icon"></i>
      <!-- 通知图标 -->
      <i class="el-icon-bell notification-icon"></i>
      <i class="el-icon-bangzhu notification-icon"></i>

      <!-- 夜间模式切换 -->
      <!-- <el-switch
        v-model="isDarkMode"
        class="dark-mode-switch"
        active-color="#13ce66"
        inactive-color="#ff4949"
        active-text="夜间"
        inactive-text="日间">
      </el-switch> -->
      <!-- 用户头像 -->
      <el-avatar icon="el-icon-user-solid" class="user-avatar"></el-avatar>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TopBar',
  data() {
    return {
      isDarkMode: false, // 用于控制夜间模式的布尔值
    };
  },
  methods: {
    toggleDarkMode() {
      this.isDarkMode = !this.isDarkMode;
      // 这里可以添加切换主题的逻辑
    },
  },
};
</script>

<style scoped>
.top-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  height: 80px; /* 根据需要调整高度 */
  background-color: #fff; /* 默认背景颜色 */
}

.logo-container {
  display: flex;
  align-items: center;
}

.logo {
  height: 50px; /* 根据实际logo尺寸调整 */
  margin-right: 10px;
}

.software-name {
  font-size: 24px;
  font-weight: bold;
}

.right-container {
  display: flex;
  align-items: center;
  gap: 10px; /* 图标之间的间距 */
}

.search-icon,
.translation-icon,
.notification-icon {
  cursor: pointer;
  font-size: 28px;
}

.dark-mode-switch {
  margin-right: 10px;
}

.user-avatar {
  margin-left: 10px;
  font-size: 28px;
  
}
</style>